import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { authApi } from "./api/authApi";
import { userApi } from "./api/userApi";
import userReducer from "./features/userSlice";
import { notificationApi } from "./api/notificationApi";
import loggedUserReducer from "./features/loggedUserSlice";
import { companyApi } from "./api/companyApi";
import { loggedUserApi } from "./api/loggedUserApi";
import companyReducer from "./features/companySlice";
import pointOfSaleApiReducer from "./features/pointOfSaleSlice";

import { pointOfSaleApi } from "./api/pointOfSaleApi";
import { provinceApi } from "./api/provinceApi";
import { operationApi } from "./api/operationApi";
import operationReducer from "./features/operationSlice";
import { documentTypeApi } from "./api/documentTypeApi";
import { profesionalActivityApi } from "./api/profesionalActivtyApi";
import { countryApi } from "./api/countryApi";
import {peopleOfInterestApi} from "./api/peopleOfinterestApi";

export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [loggedUserApi.reducerPath]: loggedUserApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [companyApi.reducerPath]: companyApi.reducer,
    [pointOfSaleApi.reducerPath]: pointOfSaleApi.reducer,
    [notificationApi.reducerPath]: notificationApi.reducer,
    [provinceApi.reducerPath]: provinceApi.reducer,
    [operationApi.reducerPath]: operationApi.reducer,
    [documentTypeApi.reducerPath]: documentTypeApi.reducer,
    [profesionalActivityApi.reducerPath]: profesionalActivityApi.reducer,
    [countryApi.reducerPath]: countryApi.reducer,
    [peopleOfInterestApi.reducerPath]: peopleOfInterestApi.reducer,
    // Connect the PostApi reducer to the store

    userLoggedState: loggedUserReducer,
    userState: userReducer,
    companyState: companyReducer,
    pointOfSaleState: pointOfSaleApiReducer,
    operationState: operationReducer,
  },
  devTools: process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({}).concat([
      loggedUserApi.middleware,
      authApi.middleware,
      userApi.middleware,
      notificationApi.middleware,
      companyApi.middleware,
      pointOfSaleApi.middleware,
      provinceApi.middleware,
      operationApi.middleware,
      profesionalActivityApi.middleware,
      documentTypeApi.middleware,
      countryApi.middleware,
      peopleOfInterestApi.middleware,
    ]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
